import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
import "./TermsAndConditions.scss";

function TermsAndConditions() {
  return (
    <div className="tc-wrap">
      <div className="container">
        <div className="heading ">
          <Slide direction="up">
            <h3>TERMS AND CONDITIONS</h3>
          </Slide>
        </div>
        <div className="content ">
          <Fade>
            <p>Terms and Conditions Effective Date: April 07, 2023 </p>
            <p>
              These terms and conditions of use (“Terms”, Terms of Use”, or
              “Agreement”) constitute a legally binding agreement and shall
              govern your access, use and enjoyment of our website,
              www.wowWishMoments.com, (the “Website”, or “Site”), owned and
              operated by Events Group International, Inc. (wowWishMoments,
              “Us”, “We”), and any related websites, domains, data, features,
              services, content, forums, or code that you may access or that is
              provided to you through the Site.
            </p>
            <p>
              You agree to the following terms and conditions: PLEASE READ THESE
              TERMS AND CONDITIONS CAREFULLY. BY ACCESSING, DOWNLOADING,
              PURCHASING, ENGAGING WITH, USING OR ATTEMPTING TO USE THE SITE,
              YOU AGREE TO BECOME BOUND BY THESE TERMS AND CONDITIONS. IF YOU DO
              NOT AGREE TO ALL OF THESE
            </p>

            <h6>
              <strong>Acceptance of Terms</strong>
            </h6>
            <p>
              By registering for, accessing, using and/or engaging with the
              Site, you expressly agree to the terms herein and agree that any
              dispute between us shall be through binding arbitration and you
              agree to be barred from engaging in any class action against
              WowWishMomemts, its owners, directors, officers, employees,
              lawyers, partners, affiliates or assigns.
            </p>

            <h6>
              <strong>Site Registration and Privacy</strong>
            </h6>
            <p>
              In order to access and use the Site, you may be required to
              complete a registration form or otherwise provide Us with personal
              information to help identify you, enable you to create a user
              account, name and password, or to provide such additional
              information so that We can provide you with access to the Site
              (“Registration”). You are the sole authorized user of your account
              and you are responsible for maintaining the confidentiality of
              your log-in credentials, account number, if any, provided to you
              by WowWishMomemts. Your password will be created by you in some
              instances and you are responsible for maintaining it in
              confidence. You are also solely and fully responsible for all
              activities that occur under your user account and/or password,
              even if not expressly authorized by you. Should you suspect any
              unauthorized party may be using your password or account, or you
              suspect any other breach of security of violation of use, you
              agree to immediately contact WowWishMomemts to report your
              suspicion or evidence of violation. By providing your email and
              phone number, you hereby affirmatively consent to Eventique’s use
              of the same to contact you regarding your account, use, enjoyment,
              engagement, changes or updates to the Site, this Agreement the
              Privacy Policy, or for any marketing purpose, including reminders,
              push notifications, feedback or other information. Any information
              that We collect from you as part of Registration, is subject to
              our Privacy Policy, which is incorporated herein by reference. You
              agree to the terms of the Privacy Policy and are responsible for
              maintaining the confidentiality of your password and other
              information that you provide to Us. We are not responsible for the
              accuracy, truthfulness or completeness of the information that you
              provide for Registration. You hereby warrant that at all times,
              the information that you provide to Us is accurate, truthful,
              complete and correct. You will be solely responsible for any
              misuse of your Registration information and you agree to
              immediately notify WowWishMomemts 1 of any suspected or actual
              unauthorized or misuse of your information. WowWishMomemts shall
              be held harmless for any damage, loss, embarrassment or otherwise,
              caused by your failure to comply maintain the privacy of your
              information. By registering for the Site, you represent and
              warrant that you have the legal authority and right to enter in
              this Agreement and that you are at least eighteen (18) years old.
              You further warrant that you have the right, authority and
              capacity to enter into and abide by the terms and conditions of
              this Agreement and the Privacy Policy.
            </p>
            <h6>
              <strong>User Generated Content</strong>
            </h6>
            <p>
              As part of your use and enjoyment of the Site, you may, from time
              to time, provide us with content in the form of comments, ideas,
              suggestions, information, images, messages, or other material,
              regardless of its medium, through chat rooms, message boards,
              comment sections, blogs, social media pages or feeds, or to us
              directly through email, US postal service, or by telephone (“User
              Generated Content”). You acknowledge and understand that none of
              the User Generated Content will be kept confidential and there is
              no expectation of privacy for any of the User Generated Content.
              You agree that any User Generated Content shall be appropriate for
              the Site and complies with this Terms of Use. You represent and
              warrant that you have the full right to use the User Generated
              Content, that it is original to you and that it does not violate
              the rights of others. By submitting User Generated Content, you
              grant WowWishMomemts, our partners, affiliates and assigns, a
              royalty-free, worldwide, perpetual, irrevocable, non-exclusive,
              fully transferrable, assignable right and license to use, copy,
              reproduce, adapt, create derivative works from, modify, publish,
              translate, perform, and display the User Generated Content, in
              whole or in part, in any form, media, or technology, now known or
              discovered or developed in the future, for any lawful or
              commercial purpose, including marketing or solicitation of
              business, with or without your personal information, including
              your name, username, or other identifiable information, subject to
              the terms of our Privacy Policy. WowWishMomemts is not responsible
              for maintaining, saving or otherwise backing up any User Generated
              Content
            </p>
            <ul>
              <li>
                WowWishMomemts reserves the right to monitor, review and edit
                any User Generated Content or information posted on or submitted
                on the Site or WowWishMomemts. In the event that any User
                Generated Content or information submitted by you to
                WowWishMomemts becomes subject to legal proceedings or
                inquiries, We reserve the right to disclose any such information
                as necessary, pursuant to any applicable law, rule, regulation,
                order, or government request. We assume no liability or
                responsibility for the impact this may have on you, your
                business or any third parties.
              </li>
              <li>
                WowWishMomemts may make chat rooms and services, bulletin
                boards, message boards, messaging services, comment sections,
                blogs or other forums available through the Site (a “Forum”).
                Each Forum may have its own rules and/or regulations that you
                agree to adhere to when you post, upload, transmit, contribute
                or otherwise engage with through the Site. Any comments,
                information or User Generated Content posted on a Forum may be
                recorded and stored in multiple places, both on our Site and
                elsewhere on the Internet. You do not have control over who will
                read any such content now, or in the future. It is your
                obligation to be selective when posting information about
                yourself or others, particularly information that is sensitive,
                embarrassing, proprietary or confidential. When engaging on or
                in a Forum, You agree that you will represent yourself in an
                honest way and shall not impersonate anyone else, or hold
                yourself out to represent anyone or any other entity, unless you
                have the express authority to do so. 2 You agree that when
                engaging on a Forum, you will not restrict or inhibit the rights
                of others, post unlawful, offensive, threatening, fraudulent,
                abusive, harassing, libelous, defamatory, obscene, vulgar,
                pornographic, profane or sexually explicit or indecent
                materials, or encourage anyone else to do the same, whether
                express, implied or through duress, engage in conduct that would
                be considered criminal, negligent or knowingly violate any
                state, city, or local law or statute, or international law,
                contain false or misleading indications of origin, contain a
                virus, spyware, Trojan horses, worms, time bombs, cancelbots, or
                other component that is designed to damage the property of
                others or to obtain private information, violate, plagiarize or
                infringe upon the intellectual property rights of of others. You
                further agree that it will not cause harm to WowWishMomemts, its
                reputation, or impact its business growth in a negative manner.
              </li>
            </ul>

            <h6>
              <strong>User Conduct</strong>
            </h6>
            <p>
              Your use of the Site is at the sole and exclusive discretion of
              WowWishMomemts. While using the Site, you warrant that you shall
              not: user false information or impersonate identity of another
              person, or claim to represent another entity without the express
              authority to do so; attempt to gain unauthorized access to other
              users’ computer systems through the Site; seek to hold yourself
              out as an agent or representative of WowWishMomemts; insert your
              own or a third party’s advertising or promotional materials or
              content onto the Site, unless authorized to do so, or use,
              republish, seek to commercialize from the Site, without the
              express approval by WowWishMomemts. Additionally, your use of the
              Site shall immediately terminate in the event hat you engage in
              any behavior that is designed to harvest the personal data of
              another user, including, without limitation, any attempt to obtain
              access to a third party computer system, materials or information;
              automatic harvesting of emails, data or other information; using
              the Site to damage, disable, interrupt, or impair its services;
              use the Site in any manner that violates the terms of this
              Agreement or the intellectual property rights of others; or use
              the Site in any manner that violates applicable law. You further
              agree that you will not encourage or support others’ attempts to
              interfere with the Site, circumvent, decrypt or reverse engineer
              it, or any content there on, or obtain or attempt to obtain user
              information through means not voluntarily or intentionally made
              publicly available from the Site by any user.
            </p>
            {/* <ul>
              <li>To facilitate our Service;</li>
              <li>To provide the Service on our behalf;</li>
              <li>To perform Service-related services; or</li>
              <li>To assist us in analyzing how our Service is used.</li>
            </ul> */}

            <h6>
              <strong>Third Party Engagement</strong>
            </h6>
            <p>
              The Site, may at times, be accessed and used by multiple users at
              a time. Each user is solely responsible for his/her/it’s behavior
              when engaging with the Site and with other users. We assume no
              responsibility for anything that you do on the Site or the
              interactions that you have on the Site, or those that were
              facilitated by the Site or by WowWishMomemts. If there is a
              dispute between you and another Site user, we are under no
              obligation to involve ourselves in the dispute. You hereby release
              and forever discharge WowWishMomemts, our directors, officers,
              employees, agents, lawyers, successors and assigns, affiliated
              companies, and partners from, and forever waive and relinquish
              each and every past, present and future dispute, claim,
              controversy, demand, right, obligation, liability, action and
              cause of action of every kind and nature, that has arisen or
              arises directly or indirectly out of, or relates directly or
              indirectly to, any interactions with, or act or omission of, other
              users. If you are a California resident, you hereby waive
              California civil code section 1542 in connection with the
              foregoing, which states: “A GENERAL RELEASE DOES NOT EXTEND TO
              CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS
              3 OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF
              KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER
              SETTLEMENT WITH THE DEBTOR.”
            </p>
            <h6>
              <strong>
                Advertisements, Marketing Materials and Promotions
              </strong>
            </h6>
            <p>
              WowWishMomemts may, from time to time, run, or allow third parties
              to run, advertisements, marketing materials or promotions
              (“Advertisements”) on the Site. Your participation or engagement
              with any Advertisement is at your sole and exclusive risk, and
              between you and the third party Advertiser. WowWishMomemts accepts
              no responsibility or liability for any loss or damage incurred by
              you as a result of your dealings with an Advertisement.
            </p>
            <h6>
              <strong>Website Linking</strong>
            </h6>
            <p>
              By using our Site, you agree that if you include any links from
              other websites, the link to the full HTML version. You are not
              permitted to link directly to any image hosted by the Site or our
              services. You agree not to download or use images that have been
              posted on our Site on any other website, for any purpose,
              including, without limitation, posting images on your own personal
              site, or the site of any competitive company. You further agree
              that you will not link from any other website to our Site in any
              manner that the Site or any pages on the Site are “framed”,
              surrounded or obfuscated by any third party branding, content, or
              materials. If you do link to our Site in any manner, we reserve
              the right to to discontinue the link and revoke your privilege to
              use our Site with or without notice to you.
            </p>
            <h6>
              <strong>Third Party Engagement</strong>
            </h6>
            <p>
              We may permit, from time to time, third parties to post links to
              their websites and may, through third parties, make certain
              products or services available to visitors to the Site (“Third
              Party Sites”). In the event that you engage with or purchase
              products or services offered by a Third Party Site, you
              acknowledge and agree that We have no responsibility for the
              information, content, products, services, advertising, code or
              other materials that may be provided by, or offered to you,
              through a Third party Site. WowWishMomemts may not endorse,
              sponsor or recommend any Third Party Site, and its placement on
              the Site does not imply any such connection. You are responsible
              to make payment pursuant to the terms of purchase from the Third
              Party Site and. WowWishMomemts is not responsible for any dispute
              between you and a Third Party Site. Any reliance on the contents
              of a Third Party Site is done at your own risk and you are
              responsible for any and all consequences of such reliance.
            </p>
            <h6>
              <strong>Limited License</strong>
            </h6>
            <p>
              Subject to the terms of this Agreement, the Privacy Policy, and
              applicable law, you hereby grant WowWishMomemts a worldwide,
              irrevocable, perpetual, non-exclusive, transferrable, royalty-free
              license, with the right to sell, use, adapt, modify, sublicense,
              distribute, publicly display, transmit, stream, broadcast, access,
              make distributive works and otherwise exploit your User Generated
              Content by any means and for any purpose, including to promote,
              market, or advertise the WowWishMomemts Platform or its services,
              or for any other purpose in Eventique’s sole discretion (the
              “License”). WowWishMomemts grants you a license to register for,
              access and use the Site, pursuant to the terms herein. This
              limited license also grants you the right to make a single copy of
              content displayed on the Site, but only for your personal,
              non-commercial use. Any commercial use of content derived from the
              site is expressly prohibited. You agree that you will not exploit,
              copy, use, modify, adapt, prepare, distribute, stream, transmit,
              broadcast, sell, transfer, publicly display or perform information
              or materials available on or through the Site for any commercial
              or promotional use, except 4 as expressly permitted herein. In the
              event that you attempt to use or actually use any information from
              the Site except as otherwise provided herein, you may violate the
              intellectual property rights protections of others and be subject
              to penalties as provided by applicable law. The Site is provided
              to you “as is” and you agree that you will not alter, delete,
              remove, edit, repurpose any of the data, code or other information
              provided on the Site for any reason whatsoever. No other rights
              shall be conveyed or granted to you except for those that have
              been expressly articulated herein
            </p>
            <h6>
              <strong>No Ownership</strong>
            </h6>
            <p>
              Nothing in this Agreement or through your Registration shall
              convey any rights in any of Eventique’s intellectual property to
              you. All text, graphics, editorial content, data, formatting,
              graphs, designs, HTML, the look and feel of the Site, photographs,
              music, sounds, images, software, code, files, look and feel,
              video, designs, trademarks, logos, slogans, typefaces,
              illustrations, and other content (the “Proprietary Material”)
              shall remain the sole and exclusive property of WowWishMomemts or
              has been authorized for use on the Site by WowWishMomemts and is
              the intellectual property of a third party. The Proprietary
              Material is protected under domestic and international copyright,
              trademark and patent law. You are not permitted to use any
              Proprietary Material without Our prior written consent or the
              consent of a third party owner of the Proprietary Material. Any
              User Generated Content is subject to separate terms as outlined
              herein. Additional information regarding the use of your personal
              information can be found in the Privacy Policy
            </p>
            <h6>
              <strong> Termination</strong>
            </h6>
            <p>
              WowWishMomemts may, at any time and for any reason, with or
              without cause, terminate any portion of the Site, and may
              terminate, limit or suspend your use and/or access to the Site,
              subject to applicable law in effect at the time of termination. We
              may also limit, remove and/or discard any User Generated Content
              submitted by you, in whole or in part, for any reason and without
              notice or liability. In the event of termination based on a breach
              of this Agreement, or a violation of intellectual rights
              protections, WowWishMomemts reserves the right to take appropriate
              legal action, including without limitation, pursuing arbitration,
              seeking injunctive relieve or other legal remedy permitted under
              this Agreement or available at law. In the event of termination as
              explained above, We reserve the right to prevent you from using
              the Site again at any time in the future, in our sole and
              exclusive discretion
            </p>
            <h6>
              <strong>Disclaimer of Warranties</strong>
            </h6>
            <p>
              WowWishMomemts makes no representation and offers no warranty
              associated with your use of the Site. Use of this service is at
              your sole risk. The Site is offered “As Is”, with no warranties,
              either express or implied, including, without limitation: fitness
              for a particular purpose, warranties of merchantability or
              non-infringement. WowWishMomemts makes no warranties or
              representations about the accuracy or completeness of the content
              provided through the Site or the content of any sites linked
              thereto and assumes no liability or responsibility for any (i)
              errors, mistakes, or inaccuracies of content, (ii) personal injury
              or property damage, of any nature whatsoever, resulting from your
              access to and use of the Site, (iii) any unauthorized access to or
              use of our secure servers and/or any and all personal information
              and/or financial information stored therein. WowWishMomemts does
              not warrant, endorse, guarantee or assume responsibility for any
              service advertised or offered by party service provider through
              the Site and will not be a party to or in any way be responsible
              for monitoring any transaction between you and any third party,
              other than as provided herein. You should use your best judgment
              and exercise caution where appropriate. Without limiting 5 the
              foregoing, neither WowWishMomemts nor its affiliates or licensors
              warrant that access to the Site will be uninterrupted or that it
              will be error-free; nor do we make any warranty as to the results
              that may be obtained from the use of our site, or as to the
              timeliness, accuracy, reliability, completeness or content of any
              good or service, information or materials provided through or in
              connection with the use of the Site. We also do not warrant that
              the site is free from viruses, worms, Trojan horses, or other
              harmful components. WowWishMomemts cannot and does not guarantee
              that any personal information supplied by you will not be
              misappropriated, intercepted, deleted, destroyed or used by
              others. In addition, notwithstanding any feature a consumer may
              use to select a party service provider, each consumer is
              responsible for determining the services they want and selecting
              their party service provider.
            </p>
            <h6>
              <strong>
                Allegations of Copyright or Trademark Infringement
              </strong>
            </h6>
            <p>
              n accordance with the Digital Millennium Copyright Act of 1998,
              Title 17 of the United States Code, Section 512 (the “DMCA”),
              WowWishMomemts shall respond promptly to claims of copyright or
              trademark infringement that are reported to Eventique’s designated
              agent, at [Support@eventiquevirtual.com]. WowWishMomemts shall
              duly investigate notices of copyright and trademark infringement
              and take appropriate actions under the DMCA, provided that an
              alleged copyright or trademark owner, or agent authorized to act
              on an owner’s behalf, provides WowWishMomemts with written
              notification of claimed infringement that includes substantially
              the following information:
            </p>
            <ul>
              <li>
                <p>
                  Identification of the copyrighted or trademarked claimed to
                  have been infringed, or, if multiple materials, a
                  representative list of such works, along with information
                  reasonably sufficient to permit us to contact you, such as an
                  address, telephone number and, if available, an email address;
                </p>
              </li>
              <li>
                {" "}
                <p>
                  Evidence of ownership of the copyrighted or trademarked
                  claimed to have been infringed;
                </p>
              </li>
              <li>
                <p>
                  {" "}
                  A physical or electronic signature of a person authorized to
                  act on behalf of the owners of an exclusive right that is
                  allegedly infringed;
                </p>
              </li>
              <li>
                <p>
                  {" "}
                  A statement that you have a bona fide or good faith belief
                  that use of the material in the manner complained of is not
                  authorized by the copyright or trademark owners, its agent, or
                  the law; and A statement that the information in the
                  notification is accurate, and under penalty of perjury, that
                  you are authorized to act on behalf of the owner of an
                  exclusive right that is allegedly infringed.
                </p>
              </li>
              <li>
                <p>
                  Agent: WowWishMomemts, 333 West 52nd Street, Suite 1008, New
                  York, NY 10019, (212) 616-1655{" "}
                </p>
              </li>
            </ul>
            <h6>
              <strong>Miscellaneous</strong>
            </h6>
            <ul>
              <li>
                <p>
                  <b>Modification:-</b> WowWishMomemts reserves the right to
                  modify and change this Agreement at any time. Such changes
                  will be effective when posted. We may only amend portions of
                  this Agreement and only to the extent allowed by applicable
                  law. By continuing to use the Site after we post any
                  modification, you accept this Agreement as modified.
                </p>
              </li>
              <li>
                <p>
                  <b>Notices:- </b>You expressly agree that WowWishMomemts, or
                  any of its affiliates, subsidiaries, directors, agents,
                  counsel or authorized person or business, may provide you with
                  notices, regarding changes or updates to this Agreement, by
                  email, regular mail, or postings on the Site, which you are
                  obligated, from time to time, to check. You may also 6 be
                  contacted by WowWishMomemts through the phone number that was
                  submitted upon Registration, by a call, text message, or other
                  appropriate means.
                </p>
              </li>
              <li>
                <p>
                  <b>No Liability :- </b>You hereby agree, acknowledge and
                  consent that you shall hold WowWishMomemts, its affiliates,
                  licensors, partners, agents, employees, officers, directors,
                  corporate partners, or participants, (the “Protected Parties”)
                  liable for any damage, suits, claims, and/or controversies
                  (collectively the “Liabilities”) that have arisen or may
                  arise, whether known or unknown, relating to your or any other
                  party’s use of or inability to use the Site, including without
                  limitation any liabilities arising in connection with the
                  conduct, act or omission of any user (including, without
                  limitation stalking, harassment, acts of physical, mental or
                  emotional violence and the destruction or damage of property)
                  any dispute with any other Site user, any instruction, advice,
                  act or service provided by WowWishMomemts, its affiliates,
                  licensors, or any of its agents, employees, officers,
                  directors, agents, counsel, corporate partners, or
                  participants, be liable for any direct, indirect, incidental,
                  consequential, special or exemplary damages arising in
                  connection with your use or inability to use the Site, and of
                  its content, materials or functions, your provision of
                  information through the Site, lost business, sales or
                  commissions, through the use of the Site or any of Eventique’s
                  related services, to the fullest extent permitted by governing
                  and applicable law. WowWishMomemts or the Protected Parties
                  shall not be liable of any damage caused or claimed in
                  connection with any material that is posted, transmitted,
                  exchanged or received, by or on behalf of you, another user of
                  the Site, or any other person on or through the Site, whether
                  authorized or unauthorized, and in no event shall the total
                  aggregate liability of a Protected Party to you for any
                  damage, loss, cause of action, including claims for
                  negligence, breach of contract, tort, or violation of Federal
                  copyright, patent or trademark, arising from your use of the
                  Site, be more than one ($1) dollar.
                </p>
              </li>
              <li>
                <p>
                  <b>
                    Indemnification :- You hereby agree to indemnify, defend,
                    hold harmless WowWishMomemts, its directors, officers,
                    employees, agents, licensors, attorneys, independent
                    contractors, providers, successors and assigns,
                    subsidiaries, parent company(ies) and affiliates, partners,
                    or related third parties, from and against any and all
                    claim, loss, expense or demand of liability, including
                    reasonable attorneys’ fees and costs incurred, in connection
                    with: (1) Your use or inability to use the Site; or (2) your
                    violation of any law or rights of any other user,
                    WowWishMomemts, or related third-party; (3) your breach or
                    violation of this Agreement, the Privacy Policy, or other
                    agreements as may be added by WowWishMomemts from time to
                    time; (4) any content submitted by you to the Site,
                    including, without limitation content that is illegal,
                    unlawful, unethical or incorrect, or infringes upon the
                    rights, including intellectual property rights of any party
                    other than you. WowWishMomemts reserves the exclusive right,
                    at your sole and exclusive expense, to assume the exclusive
                    defense and control of any matter otherwise subject to this
                    indemnification. Notwithstanding the foregoing, you shall
                    not settle any claim or matter without the express written
                    consent of WowWishMomemts which consent may be unreasonably
                    withheld, provided that the settlement includes a complete
                    release for the benefit of WowWishMomemts.
                  </b>
                </p>
              </li>
              <li>
                <p>
                  <b>
                    Entire Agreement:- This Agreement, including any attachments
                    and related agreements, including, without limitation the
                    Privacy Policy, or as otherwise may be incorporated by 7
                    reference, sets forth the entire agreement between you and
                    WowWishMomemts, with regard to the subject matter hereof.
                    All prior agreements, representations and warranties,
                    express or implied, oral or written, with respect to the
                    subject matter hereof, are superseded by this Agreement. If
                    any provision of this Agreement is deemed invalid by a court
                    of competent jurisdiction, the invalidity of such provision
                    shall not affect the validity of the remaining provisions of
                    the Agreement, which shall remain in full force and effect.
                  </b>
                </p>
              </li>
              <li>
                <p>
                  <b>
                    Assignments; Waiver; Severability :- This Agreement may not
                    be assigned by you without the prior written consent of
                    WowWishMomemts, which may be unreasonably withheld in
                    Eventique’s sole discretion and any attempt to do so shall
                    be null and void and of no effect. Failure by either party
                    at any time to require performance by the other party or to
                    claim a breach of a provision of this Agreement shall not be
                    construed as a waiver of any right accruing under this
                    Agreement, nor shall it affect any subsequent breach, the
                    effectiveness of this Agreement, or any part hereof, nor
                    shall it prejudice either party regarding any subsequent
                    action. No provision may be amended, modified, terminated,
                    or revoked, except by a writing signed by all parties
                    hereto. This Agreement shall inure to the benefit of and be
                    binding upon the parties hereto and their respective
                    successors and any permitted assigns. If any provisions of
                    this Agreement shall be invalid, illegal, or unenforceable
                    for any reason, the remaining terms and provisions shall be
                    unaffected thereby and shall continue in full force and
                    effect.
                  </b>
                </p>
              </li>
              <li>
                <p>
                  <b>
                    Construction :- Each party represents that they have read
                    this Agreement, and that they have had the opportunity to
                    review the same with an attorney of its choice. All counsel
                    shall be held harmless in the event that there is any
                    dispute relating to the drafting, construction, or
                    interpretation of this Agreement.
                  </b>
                </p>
              </li>
              <li>
                <p>
                  <b>
                    Choice of Law and Venue :- This Agreement shall be governed
                    by and construed in accordance with the laws of the State of
                    New York, without regard to the conflicts of law provisions
                    of such State. By accessing the Site, you agree to this
                    choice of law and venue. The Parties hereby further
                    irrevocably and unconditionally waive and agree not to plead
                    or claim that any action, suit or proceeding has been
                    brought in an inconvenient forum. You agree that regardless
                    of any statute or law to the contrary, any claim arising out
                    of or relating to this Agreement or the Site, or any
                    services offered by WowWishMomemts on the Site must commence
                    within six (6) months after the claim or cause of action
                    arises. Otherwise, such claim or cause of action is
                    permanently barred, unless not permitted by relevant law.
                  </b>
                </p>
              </li>
              <li>
                <p>
                  <b>
                    Section Headings :-The use of section headings in this
                    Agreement are for the convenience of the parties only and
                    have no legally binding or contractual effect.
                  </b>
                </p>
              </li>
            </ul>
            <h6>
              <strong>Contact Us</strong>
            </h6>
            <p>
              If you have any questions or suggestions about our Privacy Policy,
              do not hesitate to contact us at{" "}
              <b>
                <a href="mailto:WowWishMoments@gmail.com">
                  WowWishMoments@gmail.com
                </a>
              </b>
            </p>
          </Fade>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
